import {
  IFillDataWizardBuy,
  TBooleanKeysOfIFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import SelectionByOwnBuyStep_1 from "../selectionByOwnAppSteps/buy/step_1";
import SelectionByOwnBuyStep_10 from "../selectionByOwnAppSteps/buy/step_10";
import SelectionByOwnBuyStep_11 from "../selectionByOwnAppSteps/buy/step_11";
import SelectionByOwnBuyStep_12 from "../selectionByOwnAppSteps/buy/step_12";
import SelectionByOwnBuyStep_13 from "../selectionByOwnAppSteps/buy/step_13";
import SelectionByOwnBuyStep_14 from "../selectionByOwnAppSteps/buy/step_14";
import SelectionByOwnBuyStep_2 from "../selectionByOwnAppSteps/buy/step_2";
import SelectionByOwnBuyStep_3 from "../selectionByOwnAppSteps/buy/step_3";
import SelectionByOwnBuyStep_4 from "../selectionByOwnAppSteps/buy/step_4";
import SelectionByOwnBuyStep_5 from "../selectionByOwnAppSteps/buy/step_5";
import SelectionByOwnBuyStep_6 from "../selectionByOwnAppSteps/buy/step_6";
import SelectionByOwnBuyStep_7 from "../selectionByOwnAppSteps/buy/step_7";
import SelectionByOwnBuyStep_8 from "../selectionByOwnAppSteps/buy/step_8";
import SelectionByOwnBuyStep_9 from "../selectionByOwnAppSteps/buy/step_9";

const getSelectionByOwnAppBuySteps = (
  data: IFillDataWizardBuy,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataBoolean: (
    data: boolean,
    key: TBooleanKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStepDisabled_aim: boolean;
    isNextStepDisabled_finance: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeView: boolean;
    isNextStepDisabled_selectedTypeIds: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStepDisabled_selectedPolygonIds: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
    isDoublePrevSteps: boolean;
    isTriplePrevSteps: boolean;
  }
) => {
  //сценартий выхода на покупку

  const {
    isNextStepDisabled_aim,
    isNextStepDisabled_finance,
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeView,
    isNextStepDisabled_selectedTypeIds,
    isNextStep_viewRealtorParticipation,
    isNextStepDisabled_selectedPolygonIds,
    isNextStep_timeIntervalTypeCommunication,
    isDoublePrevSteps,
    isTriplePrevSteps,
  } = disabledAndPrev;

  return [
    <SelectionByOwnBuyStep_1
      buildingId={data.buildingId}
      onChange={handleChangeDataNumber}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_2
      isNextStepDisabled={isNextStepDisabled_selectedPolygonIds}
      onChange={handleChangeDataNumber}
      data={data.desiredLocationIds}
      onReset={onReset}
      buildingId={data.buildingId}
    />,
    <SelectionByOwnBuyStep_3
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      doublePrevStep={isDoublePrevSteps}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_4
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <SelectionByOwnBuyStep_5
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_6
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <SelectionByOwnBuyStep_7
      isNextStepDisabled={isNextStepDisabled_finance}
      data={data.finance}
      onChange={handleChangeDataBoolean}
      triplePrevStep={isTriplePrevSteps}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_8
      isNextStepDisabled={isNextStepDisabled_aim}
      onChange={handleChangeDataString}
      data={data.aim}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_9 />,
    <SelectionByOwnBuyStep_10
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_11
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_12
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_13
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <SelectionByOwnBuyStep_14 data={data} />,
  ];
};

export default getSelectionByOwnAppBuySteps;
